<template lang="pug">
td.app-time-grid-header-table-data.fc-day-header.fc-mon.fc-past(:class="{ 'fc-today is-today active': isToday }")
  .fc-cell-content
    .scheduler-heading-date
      .scheduler-heading-date-day-of-month(data-testid="scheduler-heading-date-day-of-month")
        | {{ monthDate }}
      .scheduler-heading-date-day-of-month.day-month
        .scheduler-heading-date-day-of-week
          | {{ day }}
        .scheduler-heading-date-month-name.pt-5
          | {{ month }}
</template>
<script>
export default {
  name: 'AppTimeGridHeaderTableData',
  props: {
    date: { type: Object },
    zone: { type: String },
  },
  computed: {
    now() {
      return moment().tz(this.zone);
    },
    isToday() {
      return this.date.isSame(this.now, 'day');
    },
    monthDate() {
      return this.date.format('D');
    },
    day() {
      return this.date.format('ddd').toUpperCase();
    },
    month() {
      return this.date.format('MMM');
    },
  },
};
</script>
